const MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'] as const;

const BASE_WIDTH = 336;
const BASE_HEIGHT = 224;

export const getImageSize = (itemSize: number) => {
  const prop = itemSize / BASE_WIDTH;
  const newHeight = BASE_HEIGHT * prop;
  return { width: itemSize - 2, height: newHeight };
};

export const formatItemDate = (dateStr: string | undefined | null): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return `${date.getDate()}-${MONTHS[date.getMonth()]}`;
};

export const getItemDate = (item: { date?: string; plannedStart?: string }): string | null => {
  const dateStr = item.date || item.plannedStart;
  if (!dateStr) return null;
  return formatItemDate(dateStr);
};

export const truncatePartCode = (partCode: string, maxLength = 12): string => {
  if (!partCode) return '';
  return partCode.length > maxLength ? partCode.substring(0, maxLength) + '...' : partCode;
};

export const getDisplayOrderNumber = (item: { productionOrder?: string; productionOrderNumber?: string }): string => {
  return item.productionOrder || item.productionOrderNumber || '';
};
